import { render } from "./AppNav.vue?vue&type=template&id=3a28e581"
import script from "./AppNav.vue?vue&type=script&lang=js"
export * from "./AppNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wsaunders/Sites/plant.glympton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__